import type { UpsellSeenState } from 'fym-shared/src/music24/watermarkUpsell';

function dateOrNull(value: unknown): string | null {
  return typeof value === 'string' ? value : null;
}

/**
 * The `upsellSeen` field of the `onboarding.state` answer, or null when the answer has none (an
 * older server). Null means "not known": no automatic modal opens then.
 */
export function upsellSeenOf(state: unknown): UpsellSeenState | null {
  if (typeof state !== 'object' || state === null || !('upsellSeen' in state)) {
    return null;
  }
  const seen = state.upsellSeen;
  if (typeof seen !== 'object' || seen === null) {
    return null;
  }
  const fields = seen as Record<string, unknown>;
  return {
    firstFile: dateOrNull(fields.firstFile),
    lastDay: dateOrNull(fields.lastDay),
    free: dateOrNull(fields.free),
  };
}
